import { Flex } from 'antd';
import logo from '../../../assets/company/logo.png';
import OTPCard from '../../../components/otp/OTPCard';
import ChangePassword from '../components/ChangePassword';
import ResetPassword from '../components/ResetPassword';
import SignInSection from '../components/SingInSection';
import ForgetPassword from '../components/ForgetPassword';
import { useOTPContext } from '../../../contexts/OtpContext';
import { SignInStageEnum } from '../../../enums/SignInStage';
import { useTranslation } from 'react-i18next';

interface SignInStagesSectionProps {
  signInStage: SignInStageEnum;
  onChangeState: (newState: SignInStageEnum) => void;
}

const SignInStagesSection: React.FC<SignInStagesSectionProps> = ({
  signInStage,
  onChangeState,
}) => {
  const { t } = useTranslation(['signIn', 'common', 'form']);
  const { getEmail } = useOTPContext();
  const email = getEmail();

  return (
    <Flex className="w-full pt-10" justify="center" align="center" vertical gap={8}>
      {signInStage === SignInStageEnum.SIGN_IN && <SignInSection onChangeStage={onChangeState} />}
      {signInStage === SignInStageEnum.CHANGE_PASSWORD && (
        <ChangePassword onChangeStage={onChangeState} />
      )}
      {signInStage === SignInStageEnum.OTP && (
        <OTPCard
          title={t('verifyYourEmail')}
          description={
            <>
              {t('weSent6Digit')} <span className="font-bold">{email}</span>, {t('pleaseEnterCode')}
            </>
          }
          logo={logo}
          length={6}
          buttonText={t('Submit')}
          onChangeStage={onChangeState}
          isForgetPassword={false}
        />
      )}
      {signInStage === SignInStageEnum.FORGET_PASSWORD && (
        <ForgetPassword onChangeStage={onChangeState} />
      )}
      {signInStage === SignInStageEnum.FORGET_PASSWORD_OTP && (
        <OTPCard
          title={t('forgetPasswordOTPValidation')}
          description={
            <>
              {t('weSent6Digit')} <span className="font-bold">{email}</span>. {t('pleaseEnterCode')}
            </>
          }
          logo={logo}
          length={6}
          buttonText={t('Submit')}
          isForgetPassword={true}
          onChangeStage={onChangeState}
        />
      )}
      {signInStage === SignInStageEnum.RESET_PASSWORD && (
        <ResetPassword onChangeStage={onChangeState} />
      )}
    </Flex>
  );
};

export default SignInStagesSection;
